import { render } from "./TrekButton.vue?vue&type=template&id=1c56a7c5"
import script from "./TrekButton.vue?vue&type=script&lang=js"
export * from "./TrekButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__